// eslint-disable-next-line no-shadow
enum NodePropertyOption {
    Investment,
    Benchmark,
    SecondaryBenchmarks,
}

export default NodePropertyOption;
